import React from "react";
import Store from "@/store";
import { Modal } from "antd";
import copy from "copy-to-clipboard";
import { getExplore } from "./browser";
import { getVersion } from "@/services/version";

async function contactServiceClick(e: React.MouseEvent<HTMLAnchorElement, MouseEvent>, target: string) {
    e?.preventDefault();

    const browser = getExplore();

    const info = `「软件版本:${getVersion()};浏览器信息:${browser}」</br> 「userId:${Store.currentUser.id},userName:${
        Store.currentUser.username
    }」`;

    Modal.info({
        title: "当前的用户版本",
        width: 550,
        content: (
            <div>
                <p className="light mb10" dangerouslySetInnerHTML={{ __html: info }}></p>

                <p className="error">请复制用户版本信息发给客服,再描述具体问题或者建议</p>
            </div>
        ),
        okText: "复制信息并联系客服",
        onOk() {
            copy(info);

            window.open(target, "_blank");
        },
        cancelText: "取消",
        okCancel: true,
    });
}

export default contactServiceClick;
